<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-paw"></i>
								Tour Requisitions&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i class="nav-icon fas fa-paw"></i
												>&nbsp;&nbsp;Operations&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;Tour Requisitions&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row mb-1 d-flex p-2">
									<div class="col-md-12">
										<div class="mb-1">
											<label for="agent_id" class="form-label"
												>Select Registered Tour</label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												placeholder="Select Registerd Tour"
												:items="infiniteTours.data"
												v-model="filterRequests.tour"
												@update:modelValue="selectTour($event)"
												:item-title="tourSelect"
												item-value="id"
												clearable
											>
											</v-autocomplete>
										</div>
									</div>
									<div
										class="col-md-3 justify-content-start align-items-center gap-2 d-none"
										style="font-family: HeaderCustomFont"
									>
										<button
											type="submit"
											id="Filter"
											class="btn btn-info rounded-0 text-white"
										>
											<i class="nav-icon fas fa-filter"></i>&nbsp;&nbsp;Filter
										</button>
										<button
											type="button"
											id="Export"
											class="btn btn-danger rounded-0 text-white"
										>
											<i class="nav-icon fas fa-window-close"></i
											>&nbsp;&nbsp;Clear
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row mb-1 d-flex p-2">
									<div class="col-md-12">
										<div class="mb-1 d-none">
											<label for="agent_id" class="form-label"
												>Select Registered Tour</label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												placeholder="Select Registerd Tour"
												:items="this.infiniteTours.data"
												v-model="filterRequests.tour"
												:item-title="tourSelect"
												item-value="id"
												clearable
											>
											</v-autocomplete>
										</div>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('requests')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Requisition
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchRequests"
														label="Search Tour Guests"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="requestPerPage"
														:headers="requesttHeaders"
														:items="requests"
														:search="searchRequests"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr
																v-for="(item, index) in items"
																:key="item.name"
																@click="selectRequisition(item)"
																class="clickable-row"
																:class="{
																	'selected-row':
																		selectedRequest &&
																		item.id === selectedRequest.id,
																}"
															>
																<td>{{ index + 1 }}</td>
																<td>{{ item.item }}</td>
																<td>{{ item.variation }}</td>
																<td>{{ item.guest }}</td>
																<td>{{ item.unit }}</td>
																<td>{{ item.qty }}</td>
																<td>{{ item.total }}</td>
																<td class="d-none">
																	<v-icon large @click="deleteRecord(item)">
																		mdi-access-point-remove
																	</v-icon>

																	<v-icon large @click="editRecord(item)">
																		mdi-pencil
																	</v-icon>

																	<v-icon large @click="displayReport(item)">
																		mdi-file-document
																	</v-icon>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</div>
									<div
										class="col-md-3 justify-content-start align-items-center gap-2 d-none"
										style="font-family: HeaderCustomFont"
									>
										<button
											type="submit"
											id="Filter"
											class="btn btn-info rounded-0 text-white"
										>
											<i class="nav-icon fas fa-filter"></i>&nbsp;&nbsp;Filter
										</button>
										<button
											type="button"
											id="Export"
											class="btn btn-danger rounded-0 text-white"
										>
											<i class="nav-icon fas fa-window-close"></i
											>&nbsp;&nbsp;Clear
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.optionalCosts">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Requisition Items
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('items')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Request Items
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchItems"
														label="Search Tour Costs"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="itemsPerPage"
														:headers="itemHeaders"
														:items="filteredItems"
														:search="searchItems"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr
																v-for="(item, index) in items"
																:key="item.name"
															></tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
			</div>

			<v-dialog v-model="requestModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageRequests(this.tourRequisition, 'update')
								: manageRequests(this.tourRequisition, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Requisition
								</h5>
							</div>
							<v-icon @click="closeModal('requests')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="">
												<label for="client_id" class="form-label"
													><span
														v-if="tourRequisition.errors.has('tour_id')"
														class="text-danger text-lowercase"
													>
														{{ tourRequisition.errors.get("tour_id") }} </span
													><span v-else>Select Tour</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour"
													:items="this.infiniteTours.data"
													v-model="tourRequisition.tour_id"
													item-value="id"
													item-title="name"
													id="tour_id"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-6">
											<label for="amount" class="form-label"
												><span
													v-if="tourRequisition.errors.has('amount')"
													class="text-danger text-lowercase"
												>
													{{ tourRequisition.errors.get("amount") }} </span
												><span v-else>Amount</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Total Budget Amount"
												v-model="tourRequisition.amount"
												id="amount"
											></v-text-field>
										</div>
										<div class="col-md-3">
											<label for="status" class="form-label"
												><span
													v-if="tourRequisition.errors.has('status')"
													class="text-danger text-lowercase"
												>
													{{ tourRequisition.errors.get("status") }} </span
												><span v-else>Status</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Budget Status"
												:items="[
													'draft',
													'submitted',
													'reviewed',
													'approved',
													'rejected',
												]"
												v-model="tourRequisition.status"
												id="payt_category"
											>
											</v-autocomplete>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('requests')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="itemModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageItems(this.requisitionItem, 'update')
								: manageItems(this.requisitionItem, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-handshake"
									/>&nbsp;&nbsp;Requisition Item
								</h5>
							</div>
							<v-icon @click="closeModal('items')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-6 required">
											<div class="">
												<label for="client_id" class="form-label"
													><span
														v-if="requisitionItem.errors.has('budget_id')"
														class="text-danger text-lowercase"
													>
														{{ requisitionItem.errors.get("budget_id") }} </span
													><span v-else>Select Requisition</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour"
													:items="this.infiniteBudgets.data"
													v-model="requisitionItem.budget_id"
													item-value="id"
													item-title="name"
													id="budget_id"
												>
												</v-autocomplete>
											</div>
										</div>

										<div class="col-md-3 required">
											<label for="category" class="form-label"
												><span
													v-if="requisitionItem.errors.has('category')"
													class="text-danger text-lowercase"
												>
													{{ requisitionItem.errors.get("category") }} </span
												><span v-else>Expense Category</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Expense Category"
												:items="this.infiniteTypes.data"
												v-model="requisitionItem.category"
												item-value="id"
												item-title="name"
												id="category"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-3 required">
											<label for="supplier_id" class="form-label"
												><span
													v-if="requisitionItem.errors.has('supplier_id')"
													class="text-danger text-lowercase"
												>
													{{ requisitionItem.errors.get("supplier_id") }} </span
												><span v-else>Supplier</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Expense Category"
												:items="this.infiniteTypes.data"
												v-model="requisitionItem.supplier_id"
												item-value="id"
												item-title="name"
												id="supplier_id"
											>
											</v-autocomplete>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-2 required">
											<label for="amount" class="form-label"
												><span
													v-if="requisitionItem.errors.has('amount')"
													class="text-danger text-lowercase"
												>
													{{ requisitionItem.errors.get("amount") }} </span
												><span v-else>Quantity</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Item Budget Amount"
												v-model="requisitionItem.amount"
												id="amount"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<label for="amount" class="form-label"
												><span
													v-if="requisitionItem.errors.has('amount')"
													class="text-danger text-lowercase"
												>
													{{ requisitionItem.errors.get("amount") }} </span
												><span v-else>Unit Amount</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Item Budget Amount"
												v-model="requisitionItem.amount"
												id="amount"
											></v-text-field>
										</div>
										<div class="col-md-5 required">
											<label for="amount" class="form-label"
												><span
													v-if="requisitionItem.errors.has('amount')"
													class="text-danger text-lowercase"
												>
													{{ requisitionItem.errors.get("amount") }} </span
												><span v-else>Total Amount</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Item Budget Amount"
												v-model="requisitionItem.amount"
												id="amount"
											></v-text-field>
										</div>
										<div class="col-md-2 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="requisitionItem.errors.has('currency')"
														class="text-danger text-lowercase"
													>
														{{ requisitionItem.errors.get("currency") }} </span
													><span v-else>Currency</span></label
												><v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Currency"
													:items="['USD', 'UGX', 'RWF', 'TSHS', 'KSHS']"
													v-model="requisitionItem.currency"
													id="currency"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12 required">
											<label for="description" class="form-label"
												><span
													v-if="requisitionItem.errors.has('description')"
													class="text-danger text-lowercase"
												>
													{{ requisitionItem.errors.get("description") }} </span
												><span v-else>Item Detail</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Item Description"
												v-model="requisitionItem.description"
												id="description"
											></v-text-field>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('items')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			message: "",
			http_code: "",
			user: [],
			requestModal: false,
			itemModal: false,
			breakdownModal: false,
			infiniteTours: [],
			infiniteBudgets: [],
			infiniteItems: [],
			infiniteTypes: [],
			infiniteVariations: [],
			selectedTour: null,
			selectedRequest: null,
			editMode: false,
			filterRequests: new Form({
				start: null,
				end: null,
				tour: null,
			}),
			tourRequisition: new Form({
				id: "",
				tour_id: null,
				total_amount: "",
				status: null,
				prepared_by: "",
				reviewed_by: "",
				approved_by: "",
				rejected_by: "",
				rejection_reason: "",
				is_deleted: "",
				deleted_by: "",
				created_by: "",
				updated_by: "",
				created_at: "",
				updated_at: "",
			}),
			requisitionItem: new Form({
				id: "",
				requisition_id: null,
				item_name: "",
				supplier_id: null,
				description: "",
				quantity: "",
				unit_price: "",
				amount: "",
				created_at: "",
				updated_at: "",
			}),
			searchRequests: "",
			requestPerPage: 10,
			requests: [],
			requesttHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Tour", value: "tour", sortable: true },
				{ title: "Agent", value: "agent", sortable: true },
				{ title: "Status", value: "status", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
			],

			searchItems: "",
			itemsPerPage: 10,
			items: [],
			itemHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Item", value: "item", sortable: true },
				{ title: "Supplier", value: "supplier", sortable: true },
				{ title: "Qty", value: "qty", sortable: true },
				{ title: "Unit Cost", value: "unit", sortable: true },
				{ title: "Total", value: "total", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],

			openPanels: {
				filterTours: [0],
				tourPricing: [0],
				optionalCosts: [0],
				adminFees: [0],
				personBreakdown: [0],
			},
		};
	},
	methods: {
		openModal(modal, mode) {
			if (modal == "requests") {
				if (mode == "update") {
					this.editMode = true;
					this.requestModal = true;
				} else {
					this.editMode = false;
					this.requestModal = true;
				}
			} else if (modal == "items") {
				if (mode == "update") {
					this.editMode = true;
					this.itemModal = true;
				} else {
					this.editMode = false;
					this.itemModal = true;
				}
			}
		},
		closeModal(modal) {
			if (modal == "requests") {
				this.editMode = false;
				this.requestModal = false;
				this.tourRequisition.reset();
				this.tourRequisition.errors.clear();
			} else if (modal == "items") {
				this.editMode = false;
				this.itemModal = false;
				this.requisitionItem.reset();
				this.requisitionItem.errors.clear();
			}
		},
		async selectTour(event) {
			sessionStorage.removeItem("selected_tour");
			sessionStorage.setItem("selected_tour", JSON.stringify(event));
			this.selectedTour = event;
			this.showMessage("Tour " + event.reference_number + " selected!");
			await this.manageRequests("None", "fetch");
		},
		async selectRequisition(requisition) {
			sessionStorage.removeItem("selected_request");
			sessionStorage.setItem("selected_request", JSON.stringify(requisition));
			this.selectedRequest = requisition;
			this.showMessage("Requisition selected!");
			await this.manageItems("None", "fetch");
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "tours") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTours = [];
					this.infiniteTours = query.response;
					if (this.selectedTour) {
						this.selectTour(this.selectedTour);
					} else {
						this.showMessage("No Tour Selected");
					}
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "items") {
				api = this.api + this.prefix + "/masters/costitem";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteItems = [];
					this.infiniteItems = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "types") {
				api = this.api + this.prefix + "/masters/costtype";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTypes = [];
					this.infiniteTypes = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageRequests(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					api =
						this.api +
						this.prefix +
						"/requisition/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					this.requests = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.requests = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/requisition";
				query = await this.postData(api, this.tourRequisition);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("requests");
					this.manageRequests("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/requisition/" + event.id;
				query = await this.putData(api, this.tourRequisition);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("requests");
					this.manageRequests("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourRequisition.reset();
				console.log(event);
				this.tourRequisition.fill(event);
				this.tourRequisition.tour_id = event.tour;
				this.openModal("requests", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this requisition?"
				);
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/requisition/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.manageRequests("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
		async manageItems(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedRequest !== null) {
					api =
						this.api +
						this.prefix +
						"/requisition-item/" +
						this.selectedRequest.id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					this.items = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.items = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/requisition-item";
				query = await this.postData(api, this.requisitionItem);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("items");
					this.manageItems("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/requisition-item/" + event.id;
				query = await this.putData(api, this.requisitionItem);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("items");
					this.manageItems("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.requisitionItem.reset();
				console.log(event);
				this.requisitionItem.fill(event);
				this.requisitionItem.requisition_id = event.requisition;
				this.openModal("items", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this requisition item?"
				);
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/requisition-item/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.manageItems("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/operations/");
		},
		tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent_name) {
					return (
						item.reference_number + " (" + item.client + ") " + item.agent_name
					);
				}
			};
		},
		filteredItems() {
			if (!this.items || !this.items.data) {
				return [];
			}

			if (!this.selectedRequest) {
				return this.items.data;
			} else {
				return this.items.data.filter(
					(item) => item.requisition_id == this.selectedRequest.id
				);
			}
		},
	},
	async created() {
		await this.getInfinites("tours");

		if (this.selectedTour == null) {
			if (sessionStorage.getItem("selected_tour") !== "") {
				let selected = JSON.parse(sessionStorage.getItem("selected_tour"));
				this.selectedTour = selected;
				this.filterRequests.tour = this.selectedTour;
				this.selectTour(selected);
			}
		}
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>

<style scoped>
.clickable-row {
	cursor: pointer;
}

.clickable-row:hover {
	background-color: #f5f5f5 !important;
}

.selected-row td {
	background-color: lightblue !important;
}
</style>
